/**
 * Shiny Button Component
 * Кнопка с вращающимся градиентным бордером в стиле Vertex
 * Автор: AI Market Hub
 */

import { motion } from 'framer-motion';

export default function ShinyButton({ 
  children, 
  onClick,
  className = '',
  variant = 'default', // 'default' или 'green'
  size = 'md', // 'sm', 'md', 'lg'
  ...props 
}) {
  const sizeClasses = {
    sm: 'px-4 py-1.5 text-xs',
    md: 'px-6 py-2.5 text-sm',
    lg: 'px-8 py-3.5 text-base',
  };

  const variantClasses = {
    default: 'shiny-cta-purple',
    green: 'shiny-cta-green',
  };

  return (
    <motion.button
      className={`
        shiny-cta
        ${variantClasses[variant]}
        ${sizeClasses[size]}
        ${className}
      `}
      onClick={onClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      {...props}
    >
      <span className="relative z-10 flex items-center gap-2">
        {children}
      </span>
    </motion.button>
  );
}



